/**
 * Replaces the page with a static alert when bootstrap fails: for example when redeeming the
 * sign-in code fails on the way back from Entra, or the auth config is invalid. Angular never
 * rendered, so without this the user is left on a blank page.
 */
export function showStartupFailure(error: unknown, doc: Document = document): void {
  console.error('Sales failed to start:', error);

  const alert = doc.createElement('div');
  alert.setAttribute('role', 'alert');
  alert.style.cssText = 'font-family: sans-serif; margin: 2rem auto; max-width: 32rem; padding: 0 1rem;';
  alert.textContent =
    "Sales couldn't start. Reload the page to try again; if this keeps happening, contact the help desk.";
  doc.body.replaceChildren(alert);
}
